export default __webpack_public_path__ + "static/media/Shown Furcotte.da581fc8.jpg";